import { useEffect, useRef, useState } from "react";

export default function CommuneAutocomplete({ setValue, listeCommune }) {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCommune, setSelectedCommune] = useState(null);
  const wrapperRef = useRef(null);

  // Filtrer les communes selon la recherche
  const filteredCommunes =
    listeCommune?.data?.filter((item) =>
      item?.designation?.toLowerCase().includes(search.toLowerCase())
    ) || [];

  // Fermer le dropdown si on clique à l'extérieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (commune) => {
    setSelectedCommune(commune);
    setSearch(commune.designation);
    setValue(commune.id);
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setSearch(e.target.value);
    setIsOpen(true);
    if (!e.target.value) {
      setSelectedCommune(null);
      setValue("communeId", "");
    }
  };

  return (
    <div className="relative" ref={wrapperRef}>
      <label className="text-sm block mb-1">
        Commune <span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        value={search}
        onChange={handleInputChange}
        onFocus={() => setIsOpen(true)}
        placeholder="Rechercher une commune..."
        className="input input-bordered w-full h-10"
        autoComplete="off"
        required
      />

      {/* Dropdown des résultats */}
      {isOpen && filteredCommunes.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {filteredCommunes.map((item) => (
            <div
              key={item.id}
              onClick={() => handleSelect(item)}
              className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
            >
              {item.designation}
            </div>
          ))}
        </div>
      )}

      {/* Message si aucun résultat */}
      {isOpen && search && filteredCommunes.length === 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg p-4 text-gray-500 text-center">
          Aucune commune trouvée
        </div>
      )}
    </div>
  );
}
